<style scoped>
h1{font-size:20px;text-align: center;font-weight: bold;}
h2{line-height: 25px;font-size: 14px;font-weight: normal;text-align: left;}
</style>
<template>
  <div>
    <h1>配送发货</h1>
    <h2>凯为化学目前在上海、南京、苏州建有生产研发基地，同时配备专业化学品仓库，现代化的供管系统，保证第一时间满足您的订单需求。</h2>
    <h2>客服工作时间：周一至周五8:30-17:30，发货时间为：周一至周六，遇法定节假日，按照国家规定休假。</h2>
    <h2>工作时间之外的订单需求：您可以给我们发送电子邮件，也可以在我们的网站上申请注册账号，随时可以自助下单， 我们的工作人员会在最近的工作日为您处理订单并发货。</h2>
    <h2>订单配送情况： 中国大陆地区现货：每天16点之前截单，当天发货</h2>
    <h2>中国大陆地区以外的订单：您可以直接与我们联系，我们将尽快为您协调处理。</h2>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/heard_foot/foot_file/delivery.vue